import { createApp, nextTick } from "vue"
import { getVueComponent } from "./registry"
import { activateTooltips, disposeTooltips } from "../utils/tooltips"
import { isVueCustomElement } from "./vue_compiler_options"

/**
 * Mount a registered Vue component inside a Stimulus-controlled element.
 * The host element is passed to the component so it can dispatch DOM events
 * for cross-controller communication (e.g. search-autocomplete:preview).
 */
export function mountVueComponent(hostElement, componentName, props = {}) {
  const component = getVueComponent(componentName)

  const app = createApp(component, {
    ...props,
    hostElement,
  })

  app.config.compilerOptions.isCustomElement = isVueCustomElement

  app.mixin({
    mounted() {
      this.$nextTick(() => activateTooltips(this.$el))
    },
    updated() {
      this.$nextTick(() => activateTooltips(this.$el))
    },
    unmounted() {
      disposeTooltips(this.$el)
    },
  })

  app.mount(hostElement)
  nextTick(() => activateTooltips(hostElement))
  return app
}

export function unmountVueComponent(app) {
  if (app) {
    const hostElement = app._container
    if (hostElement) disposeTooltips(hostElement)
    app.unmount()
  }
}
